// extracted by mini-css-extract-plugin
export default {"formItemX":"CreateTeamModal_formItemX__sr3Gi"};